export default {
  VnCateCode: "",
  VnCateDesc: "",
  UserModified: localStorage.getItem("UserName"),
};
